import { ListingWithItems, PurchaseWithItems } from "@/types";
import { DbItemSelect } from "@server/db/schema";

export const getEarliestYear = (
  purchaseData: PurchaseWithItems[],
  listingData: ListingWithItems[],
  itemData: DbItemSelect[]
): number => {
  const currentYear = new Date().getFullYear();
  let earliestYear = currentYear;

  // Check purchase dates
  purchaseData.forEach((purchase) => {
    if (purchase.datePurchased) {
      const year = new Date(purchase.datePurchased).getFullYear();
      if (year < earliestYear) earliestYear = year;
    }
  });

  // Check listing dates
  listingData.forEach((listing) => {
    if (listing.listingDate) {
      const year = new Date(listing.listingDate).getFullYear();
      if (year < earliestYear) earliestYear = year;
    }
    // Also check sold dates
    if (listing.listingSoldDate) {
      const year = new Date(listing.listingSoldDate).getFullYear();
      if (year < earliestYear) earliestYear = year;
    }
  });

  // Check item sold dates
  itemData.forEach((item) => {
    if (item.soldDate) {
      const year = new Date(item.soldDate).getFullYear();
      if (year < earliestYear) earliestYear = year;
    }
  });

  return earliestYear;
};